import React from 'react';
import Layout from '../Layout/Layout';
import { Typography } from '@mui/material';

function Settings() {
    return (
        <>
            <Typography variant="h4" gutterBottom>
                Settings
            </Typography>
            <Typography variant="body1">
                Settings page content goes here.
            </Typography>
        </>
    );
}

export default Settings;
